module.exports = __webpack_public_path__ + "img/clothes.d41d8cd9.svg";